import React from 'react';

import X_ICON from '../../img/x-circle.svg';

class ProblemaItem extends React.Component{
  render(){
    return(
      <div className='problema-item-novo' data-id={this.props.value}>
        {this.props.value}
        <button type='button' className='bt-remove' href='#' onClick={this.props.onRemove}><img width={15} src={X_ICON} /></button>
      </div>
    );
  }
}

export default ProblemaItem;



// WEBPACK FOOTER //
// ./src/classes/clientes/ProblemaItem.js